import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "d-flex mobile-column" }
const _hoisted_3 = { class: "left pe-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "fw-9" }, "Nicki Minaj | Gag City Reloaded", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold" }, " Enter to win a pair of NICKI MINAJ x LØCI kicks! Winner(s) will be selected in each city of the tour. ", -1)
const _hoisted_7 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_8 = { class: "my-3" }
const _hoisted_9 = { class: "input-group border border-dark align-items-center p-2 rounded overflow-hidden" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  width: "26",
  height: "15",
  viewBox: "0 0 26 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M24.6484 5.58594C24.7526 5.5599 24.8438 5.58594 24.9219 5.66406C25 5.71615 25.0391 5.82031 25.0391 5.97656V6.64062C25.0391 6.79688 24.9609 6.90104 24.8047 6.95312C23.7109 7.21354 22.3828 7.82552 20.8203 8.78906C20.0651 9.28385 19.5573 9.58333 19.2969 9.6875C17.6302 10.5208 16.3672 10.9375 15.5078 10.9375C14.5703 10.9375 13.8542 10.651 13.3594 10.0781C12.8385 9.42708 12.6172 8.39844 12.6953 6.99219L12.8125 5.89844C12.8125 5.82031 12.7734 5.76823 12.6953 5.74219C12.6172 5.6901 12.5391 5.6901 12.4609 5.74219L11.6797 6.40625C9.67448 8.125 6.86198 10.9245 3.24219 14.8047C3.11198 14.9349 2.94271 15 2.73438 15C2.52604 14.974 2.36979 14.8828 2.26562 14.7266C2.13542 14.5182 2.10938 14.2969 2.1875 14.0625L6.09375 3.59375C6.35417 2.86458 6.21094 2.2526 5.66406 1.75781C5.3776 1.4974 5.05208 1.36719 4.6875 1.36719C4.375 1.36719 4.10156 1.45833 3.86719 1.64062L0.898438 3.63281C0.690104 3.76302 0.533854 3.73698 0.429688 3.55469L0.078125 2.89062C-0.0260417 2.73438 0.0130208 2.60417 0.195312 2.5L3.04688 0.546875C3.77604 0.130208 4.41406 -0.0390625 4.96094 0.0390625C5.53385 0.0911458 6.02865 0.3125 6.44531 0.703125C6.9401 1.11979 7.2526 1.64062 7.38281 2.26562C7.53906 2.89062 7.5 3.5026 7.26562 4.10156L4.53125 11.4453L6.67969 9.25781C9.96094 5.8724 12.0703 4.14062 13.0078 4.0625C13.3203 4.0625 13.5547 4.15365 13.7109 4.33594C14.0495 4.72656 14.1536 5.46875 14.0234 6.5625C13.8672 7.78646 13.9714 8.60677 14.3359 9.02344C14.5964 9.36198 14.987 9.53125 15.5078 9.53125C16.1849 9.53125 17.2786 9.16667 18.7891 8.4375C19.0755 8.28125 19.6094 7.96875 20.3906 7.5C22.0833 6.51042 23.5026 5.8724 24.6484 5.58594Z",
    fill: "#4A4A4A"
  })
], -1)
const _hoisted_11 = { class: "my-3" }
const _hoisted_12 = { class: "input-group border border-dark align-items-center p-2 rounded overflow-hidden" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  width: "26",
  height: "15",
  viewBox: "0 0 26 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M24.6484 5.58594C24.7526 5.5599 24.8438 5.58594 24.9219 5.66406C25 5.71615 25.0391 5.82031 25.0391 5.97656V6.64062C25.0391 6.79688 24.9609 6.90104 24.8047 6.95312C23.7109 7.21354 22.3828 7.82552 20.8203 8.78906C20.0651 9.28385 19.5573 9.58333 19.2969 9.6875C17.6302 10.5208 16.3672 10.9375 15.5078 10.9375C14.5703 10.9375 13.8542 10.651 13.3594 10.0781C12.8385 9.42708 12.6172 8.39844 12.6953 6.99219L12.8125 5.89844C12.8125 5.82031 12.7734 5.76823 12.6953 5.74219C12.6172 5.6901 12.5391 5.6901 12.4609 5.74219L11.6797 6.40625C9.67448 8.125 6.86198 10.9245 3.24219 14.8047C3.11198 14.9349 2.94271 15 2.73438 15C2.52604 14.974 2.36979 14.8828 2.26562 14.7266C2.13542 14.5182 2.10938 14.2969 2.1875 14.0625L6.09375 3.59375C6.35417 2.86458 6.21094 2.2526 5.66406 1.75781C5.3776 1.4974 5.05208 1.36719 4.6875 1.36719C4.375 1.36719 4.10156 1.45833 3.86719 1.64062L0.898438 3.63281C0.690104 3.76302 0.533854 3.73698 0.429688 3.55469L0.078125 2.89062C-0.0260417 2.73438 0.0130208 2.60417 0.195312 2.5L3.04688 0.546875C3.77604 0.130208 4.41406 -0.0390625 4.96094 0.0390625C5.53385 0.0911458 6.02865 0.3125 6.44531 0.703125C6.9401 1.11979 7.2526 1.64062 7.38281 2.26562C7.53906 2.89062 7.5 3.5026 7.26562 4.10156L4.53125 11.4453L6.67969 9.25781C9.96094 5.8724 12.0703 4.14062 13.0078 4.0625C13.3203 4.0625 13.5547 4.15365 13.7109 4.33594C14.0495 4.72656 14.1536 5.46875 14.0234 6.5625C13.8672 7.78646 13.9714 8.60677 14.3359 9.02344C14.5964 9.36198 14.987 9.53125 15.5078 9.53125C16.1849 9.53125 17.2786 9.16667 18.7891 8.4375C19.0755 8.28125 19.6094 7.96875 20.3906 7.5C22.0833 6.51042 23.5026 5.8724 24.6484 5.58594Z",
    fill: "#4A4A4A"
  })
], -1)
const _hoisted_14 = { class: "my-3" }
const _hoisted_15 = { class: "input-group border border-dark align-items-center p-2 rounded overflow-hidden" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "15",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.125 0C18.6458 0 19.0885 0.182292 19.4531 0.546875C19.8177 0.911458 20 1.35417 20 1.875V13.125C20 13.6458 19.8177 14.0885 19.4531 14.4531C19.0885 14.8177 18.6458 15 18.125 15H1.875C1.35417 15 0.911458 14.8177 0.546875 14.4531C0.182292 14.0885 0 13.6458 0 13.125V1.875C0 1.35417 0.182292 0.911458 0.546875 0.546875C0.911458 0.182292 1.35417 0 1.875 0H18.125ZM1.875 1.25C1.69271 1.25 1.53646 1.3151 1.40625 1.44531C1.30208 1.54948 1.25 1.69271 1.25 1.875V3.47656C2.16146 4.25781 4.1276 5.84635 7.14844 8.24219C7.14844 8.24219 7.33073 8.39844 7.69531 8.71094C8.0599 8.9974 8.33333 9.20573 8.51562 9.33594C8.69792 9.46615 8.93229 9.60938 9.21875 9.76562C9.53125 9.92188 9.79167 10 10 10C10.1823 10 10.3776 9.96094 10.5859 9.88281C10.7943 9.80469 11.0026 9.6875 11.2109 9.53125C11.4453 9.375 11.6406 9.23177 11.7969 9.10156C11.9792 8.97135 12.1875 8.8151 12.4219 8.63281C12.6562 8.42448 12.7995 8.29427 12.8516 8.24219C15.8724 5.84635 17.8385 4.25781 18.75 3.47656V1.875C18.75 1.69271 18.6849 1.54948 18.5547 1.44531C18.4505 1.3151 18.3073 1.25 18.125 1.25H1.875ZM18.125 13.75C18.3073 13.75 18.4505 13.6979 18.5547 13.5938C18.6849 13.4635 18.75 13.3073 18.75 13.125V5.11719C17.8385 5.84635 16.1328 7.21354 13.6328 9.21875C13.5807 9.24479 13.3984 9.38802 13.0859 9.64844C12.7995 9.90885 12.5651 10.1042 12.3828 10.2344C12.2005 10.3646 11.9661 10.5208 11.6797 10.7031C11.3932 10.8854 11.1068 11.0286 10.8203 11.1328C10.5339 11.2109 10.2604 11.25 10 11.25C9.76562 11.25 9.51823 11.2109 9.25781 11.1328C9.02344 11.0547 8.80208 10.9635 8.59375 10.8594C8.41146 10.7552 8.1901 10.625 7.92969 10.4688C7.69531 10.2865 7.5 10.1432 7.34375 10.0391C7.1875 9.90885 7.00521 9.7526 6.79688 9.57031C6.58854 9.38802 6.44531 9.27083 6.36719 9.21875C3.86719 7.21354 2.16146 5.84635 1.25 5.11719V13.125C1.25 13.3073 1.30208 13.4635 1.40625 13.5938C1.53646 13.6979 1.69271 13.75 1.875 13.75H18.125Z",
    fill: "#4A4A4A"
  })
], -1)
const _hoisted_17 = { class: "my-3" }
const _hoisted_18 = { class: "input-group border border-dark align-items-center p-2 rounded overflow-hidden" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "15",
  viewBox: "0 0 21 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.125 0C18.6458 0 19.0885 0.182292 19.4531 0.546875C19.8177 0.911458 20 1.35417 20 1.875V13.125C20 13.6458 19.8177 14.0885 19.4531 14.4531C19.0885 14.8177 18.6458 15 18.125 15H1.875C1.35417 15 0.911458 14.8177 0.546875 14.4531C0.182292 14.0885 0 13.6458 0 13.125V1.875C0 1.35417 0.182292 0.911458 0.546875 0.546875C0.911458 0.182292 1.35417 0 1.875 0H18.125ZM1.875 1.25C1.69271 1.25 1.53646 1.3151 1.40625 1.44531C1.30208 1.54948 1.25 1.69271 1.25 1.875V3.47656C2.16146 4.25781 4.1276 5.84635 7.14844 8.24219C7.14844 8.24219 7.33073 8.39844 7.69531 8.71094C8.0599 8.9974 8.33333 9.20573 8.51562 9.33594C8.69792 9.46615 8.93229 9.60938 9.21875 9.76562C9.53125 9.92188 9.79167 10 10 10C10.1823 10 10.3776 9.96094 10.5859 9.88281C10.7943 9.80469 11.0026 9.6875 11.2109 9.53125C11.4453 9.375 11.6406 9.23177 11.7969 9.10156C11.9792 8.97135 12.1875 8.8151 12.4219 8.63281C12.6562 8.42448 12.7995 8.29427 12.8516 8.24219C15.8724 5.84635 17.8385 4.25781 18.75 3.47656V1.875C18.75 1.69271 18.6849 1.54948 18.5547 1.44531C18.4505 1.3151 18.3073 1.25 18.125 1.25H1.875ZM18.125 13.75C18.3073 13.75 18.4505 13.6979 18.5547 13.5938C18.6849 13.4635 18.75 13.3073 18.75 13.125V5.11719C17.8385 5.84635 16.1328 7.21354 13.6328 9.21875C13.5807 9.24479 13.3984 9.38802 13.0859 9.64844C12.7995 9.90885 12.5651 10.1042 12.3828 10.2344C12.2005 10.3646 11.9661 10.5208 11.6797 10.7031C11.3932 10.8854 11.1068 11.0286 10.8203 11.1328C10.5339 11.2109 10.2604 11.25 10 11.25C9.76562 11.25 9.51823 11.2109 9.25781 11.1328C9.02344 11.0547 8.80208 10.9635 8.59375 10.8594C8.41146 10.7552 8.1901 10.625 7.92969 10.4688C7.69531 10.2865 7.5 10.1432 7.34375 10.0391C7.1875 9.90885 7.00521 9.7526 6.79688 9.57031C6.58854 9.38802 6.44531 9.27083 6.36719 9.21875C3.86719 7.21354 2.16146 5.84635 1.25 5.11719V13.125C1.25 13.3073 1.30208 13.4635 1.40625 13.5938C1.53646 13.6979 1.69271 13.75 1.875 13.75H18.125Z",
    fill: "#4A4A4A"
  })
], -1)
const _hoisted_20 = { class: "my-3" }
const _hoisted_21 = { class: "input-group border border-dark align-items-center p-2 rounded overflow-hidden" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  height: "15",
  width: "15",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 202.592 202.592",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("path", {
        style: {"fill":"#010002"},
        d: "M198.048,160.105l-31.286-31.29c-6.231-6.206-16.552-6.016-23.001,0.433l-15.761,15.761\n\t\t\tc-0.995-0.551-2.026-1.124-3.11-1.732c-9.953-5.515-23.577-13.074-37.914-27.421C72.599,101.48,65.03,87.834,59.5,77.874\n\t\t\tc-0.587-1.056-1.145-2.072-1.696-3.038l10.579-10.565l5.2-5.207c6.46-6.46,6.639-16.778,0.419-23.001L42.715,4.769\n\t\t\tc-6.216-6.216-16.541-6.027-23.001,0.433l-8.818,8.868l0.243,0.24c-2.956,3.772-5.429,8.124-7.265,12.816\n\t\t\tc-1.696,4.466-2.752,8.729-3.235,12.998c-4.13,34.25,11.52,65.55,53.994,108.028c58.711,58.707,106.027,54.273,108.067,54.055\n\t\t\tc4.449-0.53,8.707-1.593,13.038-3.275c4.652-1.818,9.001-4.284,12.769-7.233l0.193,0.168l8.933-8.747\n\t\t\tC204.079,176.661,204.265,166.343,198.048,160.105z M190.683,176.164l-3.937,3.93l-1.568,1.507\n\t\t\tc-2.469,2.387-6.743,5.74-12.984,8.181c-3.543,1.364-7.036,2.24-10.59,2.663c-0.447,0.043-44.95,3.84-100.029-51.235\n\t\t\tC14.743,94.38,7.238,67.395,10.384,41.259c0.394-3.464,1.263-6.95,2.652-10.593c2.462-6.277,5.812-10.547,8.181-13.02l5.443-5.497\n\t\t\tc2.623-2.63,6.714-2.831,9.112-0.433l31.286,31.286c2.394,2.401,2.205,6.492-0.422,9.13L45.507,73.24l1.95,3.282\n\t\t\tc1.084,1.829,2.23,3.879,3.454,6.106c5.812,10.482,13.764,24.83,29.121,40.173c15.317,15.325,29.644,23.27,40.094,29.067\n\t\t\tc2.258,1.249,4.32,2.398,6.17,3.5l3.289,1.95l21.115-21.122c2.634-2.623,6.739-2.817,9.137-0.426l31.272,31.279\n\t\t\tC193.5,169.446,193.31,173.537,190.683,176.164z"
      })
    ])
  ])
], -1)
const _hoisted_23 = { class: "my-3" }
const _hoisted_24 = { class: "input-group border border-dark align-items-center p-2 rounded overflow-hidden" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("svg", {
  height: "15",
  width: "15",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 202.592 202.592",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("path", {
        style: {"fill":"#010002"},
        d: "M198.048,160.105l-31.286-31.29c-6.231-6.206-16.552-6.016-23.001,0.433l-15.761,15.761\n\t\t\tc-0.995-0.551-2.026-1.124-3.11-1.732c-9.953-5.515-23.577-13.074-37.914-27.421C72.599,101.48,65.03,87.834,59.5,77.874\n\t\t\tc-0.587-1.056-1.145-2.072-1.696-3.038l10.579-10.565l5.2-5.207c6.46-6.46,6.639-16.778,0.419-23.001L42.715,4.769\n\t\t\tc-6.216-6.216-16.541-6.027-23.001,0.433l-8.818,8.868l0.243,0.24c-2.956,3.772-5.429,8.124-7.265,12.816\n\t\t\tc-1.696,4.466-2.752,8.729-3.235,12.998c-4.13,34.25,11.52,65.55,53.994,108.028c58.711,58.707,106.027,54.273,108.067,54.055\n\t\t\tc4.449-0.53,8.707-1.593,13.038-3.275c4.652-1.818,9.001-4.284,12.769-7.233l0.193,0.168l8.933-8.747\n\t\t\tC204.079,176.661,204.265,166.343,198.048,160.105z M190.683,176.164l-3.937,3.93l-1.568,1.507\n\t\t\tc-2.469,2.387-6.743,5.74-12.984,8.181c-3.543,1.364-7.036,2.24-10.59,2.663c-0.447,0.043-44.95,3.84-100.029-51.235\n\t\t\tC14.743,94.38,7.238,67.395,10.384,41.259c0.394-3.464,1.263-6.95,2.652-10.593c2.462-6.277,5.812-10.547,8.181-13.02l5.443-5.497\n\t\t\tc2.623-2.63,6.714-2.831,9.112-0.433l31.286,31.286c2.394,2.401,2.205,6.492-0.422,9.13L45.507,73.24l1.95,3.282\n\t\t\tc1.084,1.829,2.23,3.879,3.454,6.106c5.812,10.482,13.764,24.83,29.121,40.173c15.317,15.325,29.644,23.27,40.094,29.067\n\t\t\tc2.258,1.249,4.32,2.398,6.17,3.5l3.289,1.95l21.115-21.122c2.634-2.623,6.739-2.817,9.137-0.426l31.272,31.279\n\t\t\tC193.5,169.446,193.31,173.537,190.683,176.164z"
      })
    ])
  ])
], -1)
const _hoisted_26 = { class: "my-3" }
const _hoisted_27 = { class: "input-group border border-dark align-items-center p-2 rounded overflow-hidden" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "#4A4A4A",
  width: "20",
  height: "15",
  version: "1.1",
  id: "Capa_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 247.582 247.582",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("path", { d: "M196.666,93.047V76.445h10v-21h-10v-15h-25v15h-11v21h11v16.424c-29,5.64-51.581,31.564-51.581,62.617\n\t\tc0,35.162,28.69,63.769,63.852,63.769c35.163,0,63.645-28.606,63.645-63.769C247.582,124.769,225.666,99.059,196.666,93.047z\n\t\t M184.021,194.254c-21.377,0-38.769-17.392-38.769-38.769c0-21.378,17.392-38.77,38.769-38.77c21.378,0,38.77,17.392,38.77,38.77\n\t\tC222.79,176.863,205.399,194.254,184.021,194.254z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M127.581,91.404c0-35.162-28.523-63.769-63.686-63.769S0,56.242,0,91.404c0,31.068,22.666,57.003,51.666,62.625v27.99\n\t\tl-8.184-7.057l-13.471,16.039l34.295,28.945l35.335-28.831l-13.437-16.268l-9.537,7.658v-28.674\n\t\tC105.666,147.804,127.581,122.105,127.581,91.404z M25.208,91.404c0-21.377,17.392-38.769,38.77-38.769s38.77,17.392,38.77,38.769\n\t\tc0,21.378-17.392,38.77-38.77,38.77S25.208,112.782,25.208,91.404z" })
  ])
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Tell us your shoe size", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "M" }, "Men's", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "F" }, "Women's", -1)
const _hoisted_32 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "my-3" }
const _hoisted_34 = { class: "input-group border border-dark align-items-center p-2 rounded overflow-hidden" }
const _hoisted_35 = {
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {"enable-background":"new 0 0 512 512"},
  "xml:space": "preserve"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("polygon", { points: "0,336.163 0,351.837 8.164,351.837 8.164,376 23.838,376 23.838,351.837 48.164,351.837 48.164,376 63.838,376\n\t\t\t\t63.838,351.837 88.163,351.837 88.163,376 103.837,376 103.837,351.837 128.164,351.837 128.164,376 143.837,376\n\t\t\t\t143.837,351.837 168.164,351.837 168.164,376 183.837,376 183.837,351.837 208.164,351.837 208.164,376 223.838,376\n\t\t\t\t223.838,351.837 248.163,351.837 248.163,376 263.837,376 263.837,351.837 288.163,351.837 288.163,376 303.837,376\n\t\t\t\t303.837,351.837 328.164,351.837 328.164,376 343.837,376 343.837,351.837 368.163,351.837 368.163,376 383.836,376\n\t\t\t\t383.836,351.837 408.163,351.837 408.163,376 423.837,376 423.837,351.837 448.162,351.837 448.162,376 463.836,376\n\t\t\t\t463.836,351.837 488.164,351.837 488.164,376 503.837,376 503.837,351.837 512,351.837 512,336.163 \t\t\t" }),
      /*#__PURE__*/_createElementVNode("path", { d: "M503.837,152h-15.674c0,35.38-28.783,64.163-64.163,64.163S359.838,187.38,359.838,152v-12.058l-32,14.222V136h-15.674\n\t\t\t\tv25.13l-16.326,7.256v-16.385h-15.674v23.352l-16.327,7.256v-14.608h-15.674v21.574l-16.327,7.257v-12.831h-15.674v19.796\n\t\t\t\tl-16.326,7.256v-11.052h-15.674v18.018l-49.827,22.145H88c-44.022,0-79.836,35.814-79.836,79.836v7.837h495.673V152z\n\t\t\t\t M383.836,220.962c7.432,4.346,15.625,7.52,24.327,9.279v9.922h-24.327V220.962z M488.164,312.166H24.314v-0.003\n\t\t\t\tC28.19,280.466,55.273,255.837,88,255.837h45.102l56,48h290.899v-15.674H194.9l-44.379-38.04l33.644-14.953V256h15.674v-27.796\n\t\t\t\tl16.326-7.256V240h15.674v-26.017l16.327-7.256v17.274h15.674v-24.24l16.327-7.256v15.496h15.674V185.54l16.326-7.256v13.719\n\t\t\t\th15.674v-20.685l17.179-7.635c2.595,17.628,10.983,33.387,23.147,45.307v46.85h55.674v-24.004c0.054,0,0.109,0.004,0.163,0.004\n\t\t\t\tc6.151,0,12.139-0.707,17.894-2.031c5.531,21.666,23.768,38.294,46.269,41.47V312.166z M488.164,255.391\n\t\t\t\tc-15.557-3.09-27.898-15.193-31.349-30.619c12.485-5.653,23.27-14.421,31.349-25.313V255.391z" })
    ])
  ])
], -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Please select your shoe size", -1)
const _hoisted_39 = ["value"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "fs-14 text-muted mt-5" }
const _hoisted_42 = { for: "terms-checkbox" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" By continuing, you're confirming you are opting in to receive communication from VIP Nation, WILD LOCI LTD’s and/or Nicki Minaj via email. Please read our full ")
const _hoisted_44 = /*#__PURE__*/_createElementVNode("a", { href: "/Nicki%20Minaj%20Contest%20Terms%20and%20conditions.pdf" }, "Terms & Conditions", -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode(". No purchase necessary to enter or win. ")
const _hoisted_46 = {
  key: 2,
  class: "alert alert-success"
}
const _hoisted_47 = {
  key: 3,
  class: "text-center mt-5"
}
const _hoisted_48 = ["disabled"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card border-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/img2.jpg",
      class: "img-fluid card-img-top",
      alt: ""
    })
  ])
], -1)

import {Field, ErrorMessage} from "vee-validate";
import {useRouter} from "vue-router";
import {useForm} from "vee-validate";
import * as Yup from "yup";
import {ref} from "vue";
import {LpApiService} from "@/services/lpApiService";
import {onMounted} from "vue";
import {Ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Page1',
  setup(__props) {

const uploadsEnabled: Ref<undefined | boolean> = ref(undefined)
let currentEventName = ''

const conversionTable = {
  'M': {
    '6': '39',
    '6.5': '39',
    '7': '40',
    '7.5': '40-41',
    '8': '41',
    '8.5': '41-42',
    '9': '42',
    '9.5': '42-43',
    '10': '43',
    '10.5': '43-44',
    '11': '44',
    '11.5': '44-45',
    '12': '45',
    '13': '46',
    '14': '47',
    '15': '48',
    '16': '49',
  },
  'F': {
    4: '35',
    4.5: '35',
    5: '35-36',
    5.5: '36',
    6: '36-37',
    6.5: '37',
    7: '37-38',
    7.5: '38',
    8: '38-39',
    8.5: '39',
    9: '39-40',
    9.5: '40',
    10: '40-41',
    10.5: '41',
    11: '41-42',
    11.5: '42',
    12: '42-43',
  }
}

const sizesOrdered = {
  F: Object.keys(conversionTable.F).map(o => parseFloat(o)).sort((a, b) => a - b),
  M: Object.keys(conversionTable.M).map(o => parseFloat(o)).sort((a, b) => a - b),
}

onMounted(async () => {
  const settings = await LpApiService.getSetting()
  uploadsEnabled.value = settings.nicki_minaj_website_enabled
  currentEventName = settings.nicki_minaj_event_name
})

const router = useRouter();
const {values, handleSubmit} = useForm({
  initialValues: {
    last_name: '',
    first_name: '',
    email: '',
    email_confirmation: '',
    phone_number: '',
    phone_number_confirmation: '',
    terms_checkbox: '',
    gender: '',
    size: '',
  },
  validationSchema: Yup.object().shape({
    last_name: Yup.string().required("Last Name is a required field"),
    first_name: Yup.string().required("First Name is a required field"),
    email: Yup.string().required("Email is a required field"),
    email_confirmation: Yup.string().email().oneOf([Yup.ref('email')], 'Emails should must match'),
    phone_number: Yup.string().required("Phone number is a required field"),
    phone_number_confirmation: Yup.string().oneOf([Yup.ref('phone_number')], 'Phone numbers must match'),
    terms_checkbox: Yup.boolean().required("This is a required field"),
    gender: Yup.string().oneOf(['M', 'F']).required("This is a required field"),
  })
})

const dataSubmitted = ref(false)

const submitButtonDisabled = ref(false)
const onFormSubmit = handleSubmit(async (values) => {
  try {
    submitButtonDisabled.value = true;

    const metadata = {
      first_name: values.first_name,
      last_name: values.last_name,
      email: values.email,
      event_name: currentEventName,
      phone_number: values.phone_number,
      gender: values.gender,
      size: values.size,
    }

    await LpApiService.sendData(metadata)
    dataSubmitted.value = true;

    // await router.push({name: "page3", query: values})

  } catch (e) {
    alert('Error')
  } finally {
    submitButtonDisabled.value = false;
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onFormSubmit) && _unref(onFormSubmit)(...args)), ["prevent"])),
            action: ""
          }, [
            (submitButtonDisabled.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Please wait... "))
              : (!dataSubmitted.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_unref(Field), { name: "first_name" }, {
                      default: _withCtx(({field}) => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _hoisted_10,
                            _createElementVNode("input", _mergeProps(field, {
                              type: "text",
                              class: "form-control border-0",
                              placeholder: "First Name *"
                            }), null, 16)
                          ]),
                          _createVNode(_unref(ErrorMessage), {
                            name: "first_name",
                            class: "fv-plugins-message-container text-danger"
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Field), { name: "last_name" }, {
                      default: _withCtx(({field}) => [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("input", _mergeProps(field, {
                              type: "text",
                              class: "form-control border-0",
                              placeholder: "Last Name *"
                            }), null, 16)
                          ]),
                          _createVNode(_unref(ErrorMessage), {
                            name: "last_name",
                            class: "fv-plugins-message-container text-danger"
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Field), { name: "email" }, {
                      default: _withCtx(({field}) => [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("input", _mergeProps(field, {
                              type: "text",
                              class: "form-control border-0",
                              placeholder: "Email Address *"
                            }), null, 16)
                          ]),
                          _createVNode(_unref(ErrorMessage), {
                            name: "email",
                            class: "fv-plugins-message-container text-danger"
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Field), { name: "email_confirmation" }, {
                      default: _withCtx(({field}) => [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("input", _mergeProps(field, {
                              type: "text",
                              class: "form-control border-0",
                              placeholder: "Confirm Email *"
                            }), null, 16)
                          ]),
                          _createVNode(_unref(ErrorMessage), {
                            name: "email_confirmation",
                            class: "fv-plugins-message-container text-danger"
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Field), { name: "phone_number" }, {
                      default: _withCtx(({field}) => [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("input", _mergeProps(field, {
                              type: "text",
                              class: "form-control border-0",
                              placeholder: "Phone Number *"
                            }), null, 16)
                          ]),
                          _createVNode(_unref(ErrorMessage), {
                            name: "phone_number",
                            class: "fv-plugins-message-container text-danger"
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Field), { name: "phone_number_confirmation" }, {
                      default: _withCtx(({field}) => [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("input", _mergeProps(field, {
                              type: "text",
                              class: "form-control border-0",
                              placeholder: "Confirm Phone Number *"
                            }), null, 16)
                          ]),
                          _createVNode(_unref(ErrorMessage), {
                            name: "phone_number_confirmation",
                            class: "fv-plugins-message-container text-danger"
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Field), { name: "gender" }, {
                      default: _withCtx(({field}) => [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createElementVNode("select", _mergeProps({ class: "form-select shadow-none border-0" }, field), _hoisted_32, 16)
                          ]),
                          _createVNode(_unref(ErrorMessage), {
                            name: "gender",
                            class: "fv-plugins-message-container text-danger"
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    (_unref(values).gender)
                      ? (_openBlock(), _createBlock(_unref(Field), {
                          key: 0,
                          name: "size"
                        }, {
                          default: _withCtx(({field}) => [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                (_openBlock(), _createElementBlock("svg", _hoisted_35, _hoisted_37)),
                                _createElementVNode("select", _mergeProps({ class: "form-select shadow-none border-0" }, field), [
                                  _hoisted_38,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sizesOrdered[_unref(values).gender], (size) => {
                                    return (_openBlock(), _createElementBlock("option", { value: size }, _toDisplayString(size), 9, _hoisted_39))
                                  }), 256))
                                ], 16)
                              ]),
                              (_unref(values).size)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, " European size: " + _toDisplayString(conversionTable[_unref(values).gender][_unref(values).size]), 1))
                                : _createCommentVNode("", true),
                              _createVNode(_unref(ErrorMessage), {
                                name: "size",
                                class: "fv-plugins-message-container text-danger"
                              })
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("label", _hoisted_42, [
                        _createVNode(_unref(Field), {
                          type: "checkbox",
                          name: "terms_checkbox",
                          id: "terms-checkbox",
                          value: true,
                          "unchecked-value": undefined
                        }),
                        _hoisted_43,
                        _hoisted_44,
                        _hoisted_45
                      ]),
                      _createVNode(_unref(ErrorMessage), {
                        name: "terms_checkbox",
                        class: "fv-plugins-message-container text-danger"
                      })
                    ])
                  ], 64))
                : _createCommentVNode("", true),
            (dataSubmitted.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, " Entry received! You will receive a text or email before the start of the show if you are a winner "))
              : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("button", {
                    disabled: submitButtonDisabled.value,
                    class: "btn btn-dark py-2 px-5 rounded-0"
                  }, _toDisplayString(submitButtonDisabled.value ? "Please wait..." : "Submit"), 9, _hoisted_48)
                ]))
          ], 32)
        ]),
        _hoisted_49
      ])
    ])
  ]))
}
}

})